export const breakpointMobile = 840
export const breakpointDesktopWide = 1600

export const media = {
  wideDesktop: `@media screen and (min-width: ${breakpointDesktopWide}px)`,
  desktop: `@media screen and (min-width: ${breakpointMobile}px)`,
  mobile: `@media screen and (max-width: ${breakpointMobile}px)`,
}
